import {useCallback, useRef} from "react";
import {useForm} from "react-hook-form";

import {digitFields, IFormData, useDigitInputNavigation, useWebOtp} from "@pg-mono/user";

const CODE_LENGTH = digitFields.length;

const isDigitFilled = (value: IFormData[keyof IFormData]) => value != null && `${value}` !== "";

// Four-digit SMS code form: typing, paste, WebOTP autofill and focus movement between the inputs.
export const useHomeMatchPreferencesWizardSmsDigits = () => {
    const inputRefs = useRef<(HTMLInputElement | null)[]>([null, null, null, null]);
    const digitNavigation = useDigitInputNavigation(inputRefs);
    const form = useForm<IFormData>({
        defaultValues: {
            firstDigit: null,
            secondDigit: null,
            thirdDigit: null,
            fourthDigit: null
        }
    });
    const watchedDigits = form.watch(digitFields);
    const canConfirmCode = watchedDigits.every(isDigitFilled);

    const getCode = useCallback(() => {
        const values = form.getValues();

        return `${values.firstDigit ?? ""}${values.secondDigit ?? ""}${values.thirdDigit ?? ""}${values.fourthDigit ?? ""}`;
    }, [form]);

    const fillDigits = (digits: string, startIndex: number) => {
        if (!digits) return;

        digits.split("").forEach((digit, offset) => {
            const index = startIndex + offset;

            if (index < CODE_LENGTH) form.setValue(digitFields[index], Number(digit));
        });

        digitNavigation.focusFieldByIndex(Math.min(startIndex + digits.length, CODE_LENGTH) - 1);
    };

    useWebOtp({
        enabled: true,
        onCodeReceived: (code) => fillDigits(code.replace(/\D/g, "").slice(0, CODE_LENGTH), 0)
    });

    const changeDigit = (fieldName: keyof IFormData, value: string) => {
        const numeric = value.replace(/\D/g, "");
        const startIndex = digitFields.indexOf(fieldName);

        if (numeric.length > 1) {
            fillDigits(numeric.slice(0, CODE_LENGTH - startIndex), startIndex);
            return;
        }

        if (!numeric) {
            for (let index = startIndex; index < CODE_LENGTH; index++) form.setValue(digitFields[index], null);

            return;
        }

        form.setValue(fieldName, Number(numeric.slice(-1)));
        digitNavigation.moveToNextField(fieldName);
    };

    const pasteCode = (text: string) => fillDigits(text.replace(/\D/g, "").slice(0, CODE_LENGTH), 0);

    return {canConfirmCode, changeDigit, digitNavigation, form, getCode, inputRefs, pasteCode};
};
import {useCallback, useRef} from "react";
import {useForm} from "react-hook-form";

import {digitFields, IFormData, useDigitInputNavigation, useWebOtp} from "@pg-mono/user";

const CODE_LENGTH = digitFields.length;

const isDigitFilled = (value: IFormData[keyof IFormData]) => value != null && `${value}` !== "";

// Four-digit SMS code form: typing, paste, WebOTP autofill and focus movement between the inputs.
export const useHomeMatchPreferencesWizardSmsDigits = () => {
    const inputRefs = useRef<(HTMLInputElement | null)[]>([null, null, null, null]);
    const digitNavigation = useDigitInputNavigation(inputRefs);
    const form = useForm<IFormData>({
        defaultValues: {
            firstDigit: null,
            secondDigit: null,
            thirdDigit: null,
            fourthDigit: null
        }
    });
    const watchedDigits = form.watch(digitFields);
    const canConfirmCode = watchedDigits.every(isDigitFilled);

    const getCode = useCallback(() => {
        const values = form.getValues();

        return `${values.firstDigit ?? ""}${values.secondDigit ?? ""}${values.thirdDigit ?? ""}${values.fourthDigit ?? ""}`;
    }, [form]);

    const fillDigits = (digits: string, startIndex: number) => {
        if (!digits) return;

        digits.split("").forEach((digit, offset) => {
            const index = startIndex + offset;

            if (index < CODE_LENGTH) form.setValue(digitFields[index], Number(digit));
        });

        digitNavigation.focusFieldByIndex(Math.min(startIndex + digits.length, CODE_LENGTH) - 1);
    };

    useWebOtp({
        enabled: true,
        onCodeReceived: (code) => fillDigits(code.replace(/\D/g, "").slice(0, CODE_LENGTH), 0)
    });

    const changeDigit = (fieldName: keyof IFormData, value: string) => {
        const numeric = value.replace(/\D/g, "");
        const startIndex = digitFields.indexOf(fieldName);

        if (numeric.length > 1) {
            fillDigits(numeric.slice(0, CODE_LENGTH - startIndex), startIndex);
            return;
        }

        if (!numeric) {
            for (let index = startIndex; index < CODE_LENGTH; index++) form.setValue(digitFields[index], null);

            return;
        }

        form.setValue(fieldName, Number(numeric.slice(-1)));
        digitNavigation.moveToNextField(fieldName);
    };

    const pasteCode = (text: string) => fillDigits(text.replace(/\D/g, "").slice(0, CODE_LENGTH), 0);

    return {canConfirmCode, changeDigit, digitNavigation, form, getCode, inputRefs, pasteCode};
};
